import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_heading_with_icon = _resolveComponent("heading-with-icon")
  const _component_product_recommendation_item = _resolveComponent("product-recommendation-item")
  const _component_skeleton_product_recommendation_item = _resolveComponent("skeleton-product-recommendation-item")
  const _component_base_slider = _resolveComponent("base-slider")

  return ($data.isRecommendationsVisible)
    ? (_openBlock(), _createBlock(_component_base_slider, {
        key: 0,
        class: "_py-3",
        "is-processing": _ctx.isProcessing,
        "medium-screen-visible-items-count": $props.mediumScreenVisibleItemsCount,
        "large-screen-visible-items-count": $props.largeScreenVisibleItemsCount,
        "extra-large-screen-visible-items-count": $props.extraLargeScreenVisibleItemsCount,
        items: $options.mappedRecommendedProducts,
        "slide-gap-classes": "_px-2 _px-3--m",
        "scroll-container-wrapper-classes": "_pos-r _-mx-2 _-mx-3--m",
        onGetItems: $options.getProductRecommendations,
        onScrollLeft: _cache[0] || (_cache[0] = $event => ($options.onScroll('left'))),
        onScrollRight: _cache[1] || (_cache[1] = $event => ($options.onScroll('right'))),
        "data-qa": "product-recommendation-slider"
      }, {
        prefix: _withCtx(() => [
          _createVNode(_component_heading_with_icon, { tag: "h3" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.YourPledge.YourPledgeRecommendationTitle), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        slide: _withCtx(({ item }) => [
          _createVNode(_component_product_recommendation_item, {
            item: item,
            section: $props.section,
            onProductAdded: $options.onProductAdded,
            "data-qa": `recommendation-item-number:${item.productID}`
          }, null, 8 /* PROPS */, ["item", "section", "onProductAdded", "data-qa"])
        ]),
        placeholder: _withCtx(() => [
          _createVNode(_component_skeleton_product_recommendation_item)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["is-processing", "medium-screen-visible-items-count", "large-screen-visible-items-count", "extra-large-screen-visible-items-count", "items", "onGetItems"]))
    : _createCommentVNode("v-if", true)
}